// extracted by mini-css-extract-plugin
export var loadingShimmer = "_rc-2";
export var messageContent = "_rc-0";
export var messagesScroll = "_rc-1";
export var shimmer = "_rc-3";
export var shimmerW100 = "_rc-4";
export var shimmerW70 = "_rc-8";
export var shimmerW80 = "_rc-7";
export var shimmerW85 = "_rc-6";
export var shimmerW90 = "_rc-5";